<section class="aayn-audience--gender-selection">
  <button ayn-button="primary" icon="male">Male</button>

  <button ayn-button="primary" class="__not-selected" icon="female">Female</button>
</section>
